import DougImage from './doug.webp'
import JohnImage from './john.webp'
import RachelImage from './rachel.webp'

export { DougImage, JohnImage, RachelImage }
